import { apiCaller } from "../../../services/apiCaller";
import { API } from "../../../services/services";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { responseValidator } from "../../helpers";
import { useEffect } from "react";
import { setUserInfo } from "../../../redux/slices/userSlice";
import { conditions } from "../../conditions/conditions";
import { ConditionName, UserQuizStatus } from "../../../interfaces/enums";
import { setUserStatus } from "redux-share/slices/quizSlice";
import { shallowEqual } from "react-redux";

const useGetProfile = () => {
    const dispatch = useAppDispatch();
    const { isFetchDetails, params } = useAppSelector(({ videoData: { isFetchDetails, params } }) => ({ isFetchDetails, params }), shallowEqual);

    useEffect(() => {
        (async () => {
            if (conditions(ConditionName.getUserProfile)) {
                const response = await apiCaller({
                    url: API().user.profileWithXTokenNasle3,
                    method: "GET",
                    headers: { authorization: `Bearer ${params.xToken}` }
                });
                if (response && response.status < 400) {
                    const user = {
                        name: response.data.displayName,
                        avatar_url: response.data.image,
                        phone_number: response.data.phoneNumber,
                        id: response.data.id
                    };
                    dispatch(setUserInfo(user));
                    if (conditions(ConditionName.hasQuizParams)) dispatch(setUserStatus(UserQuizStatus.participant));
                } else {
                    const { data, status } = await apiCaller({ url: API().user.profileWithXToken, method: "POST", data: { token: params.xToken } });
                    if (responseValidator(status)) {
                        dispatch(setUserInfo(data.data));
                        if (conditions(ConditionName.hasQuizParams)) dispatch(setUserStatus(UserQuizStatus.participant));
                    } else if (conditions(ConditionName.hasQuizParams)) dispatch(setUserStatus(UserQuizStatus.participant));
                }
            }
        })();
    }, [isFetchDetails, params.xToken]);
};

export default useGetProfile;
